module.exports = __webpack_public_path__ + "img/hero.9c8fc7ee.png";